let accessToken: string | null = null;

export const authTokenVault = {
  clear() {
    accessToken = null;
  },
  get() {
    return accessToken;
  },
  set(token: string) {
    accessToken = token.trim() || null;
  },
};
